import React from 'react'
import styles from './FourOhFour.scss'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { Card } from 'common/styleguide/Card'
import { CTA } from 'common/styleguide/CTA'
import { Icon } from 'common/Icon'
import { Msg, commonCTAs } from 'lib/localization'
import { defineMessages } from 'react-intl'
import { withRouter } from 'react-router-dom'

export const fourOhFourMessages = defineMessages({
  header: {
    id: 'FourOhFour.header',
    defaultMessage: 'The page you are looking for does not exist.'
  },
  message: {
    id: 'FourOhFour.message',
    defaultMessage: 'If you expect something to be here, please submit a Support ticket. Thanks!'
  },
  submit: {
    id: 'FourOhFour.submit',
    defaultMessage: 'Submit a Support Ticket'
  }
})

export class _FourOhFour extends React.PureComponent {
  submitClicked = (e) => {
    if (window.zE) {
      e.preventDefault()
      window.zE('webWidget', 'show')
      window.zE('webWidget', 'open')
    }
  }

  render () {
    const { history } = this.props
    return (
      <StandardLayout greyBg>
        <div className={styles.FourOhFour}>
          <Card>
            <div className={styles.icon}>
              <Icon i='md-bicycle' size={50} />
            </div>
            <h2><Msg m={fourOhFourMessages.header} /></h2>
            <p style={{ marginBottom: '20px' }}>
              <Msg m={fourOhFourMessages.message} />
            </p>
            <div>
              <CTA inline margins={false} onClick={this.submitClicked} href='https://ridewithgps.zendesk.com/hc/en-us/requests/new'>
                <Msg m={fourOhFourMessages.submit} />
              </CTA>
              <CTA inline margins={false} link onClick={() => history.goBack()}>
                <Msg m={commonCTAs.goBack} />
              </CTA>
            </div>
          </Card>
        </div>
      </StandardLayout>
    )
  }
}

export const FourOhFour = withRouter(_FourOhFour)
